<mat-dialog-content>
  <span class="subheader">Artikel zur Nachlieferung aufnehmen</span>
</mat-dialog-content>
@if (!success) {
  <mat-dialog-content>
    <form [formGroup]="productForm">
      <mat-form-field appearance="outline" class="mt-s">
        <mat-label>Artikelname oder PZN</mat-label>
        <input matInput formControlName="search" [matAutocomplete]="auto" (input)="searchProducts($event)"/>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setProduct($event.option.value)">
          @for (product of products; track product) {
            <mat-option [value]="product.pzn+' '+product.name">
              {{ product.pzn }} {{ product.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field appearance="outline" class="mt-s">
        <mat-label>Menge</mat-label>
        <input matInput formControlName="qty" (change)="checkDetails()"/>
      </mat-form-field>
      <div>
        <p>Information lt. Hersteller</p>
        @if (!loadingStatus) {
          <div>
            @if (deliveryStatus) {
              <p>{{ deliveryStatus | translate }}</p>
            }
            @if (deliveryDate) {
              <p>KW {{ getDate(deliveryDate) | date: 'w / Y' }}</p>
            }
          </div>
        } @else {
          <mat-spinner [diameter]="20"></mat-spinner>
        }
      </div>
    </form>
    @if (error) {
      <div>Es ist ein Fehler aufgetreten, bitte versuchen Sie es später noch einmal.</div>
    }
  </mat-dialog-content>
} @else {
  <mat-dialog-content>
    <p>Artikel zur Nachlieferung aufgenommen.</p>
  </mat-dialog-content>
}
<mat-dialog-content>
  <button mat-flat-button (click)="onNoClick()">Abbrechen</button>
  @if (!success) {
    <button mat-flat-button color="primary" (click)="addNachlieferung($event)" [disabled]="disabled">
      Aufnehmen
    </button>
  }
</mat-dialog-content>
